module.exports = __webpack_public_path__ + "static/media/icon_events.fa8d6fab.svg";